import { Link } from "react-router-dom";
import { Logo } from "@/components/shared";

const IMG = "https://images.unsplash.com/photo-1518980120692-3cfe64c152d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="ait-bg min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#050811]/60 to-[#050811]" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <Logo size="lg" variant="full" />
          <div>
            <h2 className="font-heading text-3xl font-bold text-white leading-tight max-w-sm">
              Next-Generation <span className="text-gradient">Digital Asset</span> Technology
            </h2>
            <p className="text-slate-400 mt-4 max-w-sm text-sm">Secure, transparent and built for clarity. Returns are variable and never guaranteed.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md animate-fadeup">
          <div className="lg:hidden mb-8 flex justify-center"><Logo size="md" variant="full" /></div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">{title}</h1>
          {subtitle && <p className="text-slate-400 mt-2 text-sm">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-400">{footer}</div>}
          <p className="mt-8 text-center"><Link to="/" className="text-xs text-slate-500 hover:text-cyan-400">← Back to home</Link></p>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, testId, error, ...props }) {
  return (
    <div>
      <label className="text-sm text-slate-300 mb-1.5 block">{label}</label>
      <input data-testid={testId} {...props}
        className={`w-full bg-slate-900/60 border rounded-lg px-4 py-2.5 text-slate-100 placeholder:text-slate-600 focus:outline-none transition-colors ${error ? "border-red-500/50" : "border-cyan-500/20 focus:border-cyan-400"}`} />
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
    </div>
  );
}
